import { Box } from "@chakra-ui/react";
import { palette } from "./theme";

/**
 * Keyed by colour name, not hex: callers pass "green", and an unknown key
 * falls back to blue rather than rendering an unstyled badge.
 */
const badgeColors: Record<string, { bg: string; color: string }> = {
  blue: { bg: "#EBF8FF", color: palette.blue },
  green: { bg: "#CFF5D1", color: palette.green },
  yellow: { bg: "#FEF3C7", color: "#B7791F" },
  red: { bg: "#FFCBCB", color: palette.red },
  purple: { bg: "#F4F0FF", color: palette.purpleDark },
};

export const StatusBadge = ({
  color,
  children,
}: React.PropsWithChildren<{ color: string }>): JSX.Element => {
  const colors = badgeColors[color] ?? badgeColors.blue;
  return (
    <Box
      as="span"
      px={2.5}
      py={1}
      borderRadius="full"
      bg={colors.bg}
      color={colors.color}
      fontSize="11px"
      fontWeight="700"
      whiteSpace="nowrap"
    >
      {children}
    </Box>
  );
};
